import axios from "axios"
const BASE_URL = process.env.REACT_APP_API_URL

class SeoApi {

  getSeo(config) {
    return axios.get(`${BASE_URL}/seo/get`, config)
  }

  addSeo(data, config) {
    return axios.post(`${BASE_URL}/seo/add`, data, config)
  }
  getSeoById(id, config) {
    return axios.get(`${BASE_URL}/seo/get/${id}`, config)
  }
  updateSeo(id, data, config) {
    return axios.put(`${BASE_URL}/seo/update/${id}`, data, config)
  }
}

export default new SeoApi()
